import React, { useState } from "react";
import { Table, Button } from "react-bootstrap";
import DateFormat from "../UI/DateFormat";
import Status from "../UI/Status";
import ProjectLogo from "../UI/ProjectLogo";
import Modal from "../UI/Modal";
import Pagination from "../UI/Pagination";
import ConfirmModal from "components/UI/ConfirmModal";
import Loading from "components/UI/Loading";
import { Link } from "react-router-dom";
import Investor from "components/UI/Investor";
import FundraisingView from "./View";

const FundraisingList = ({
  paginationConfig,
  isLoading,
  onDelete,
  onEdit,
  onFetchRecords,
  results,
}) => {
  const [selectedItem, setSelectedItem] = useState("");
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const onClose = () => {
    document.body.classList.remove("overflow-hidden");
    setShowConfirmModal(false);
    setShowModal(false);
  };

  const onNavigationHandler = (limit, page) => {
    onFetchRecords(limit, page);
  };

  const onRemoveHandler = (item) => {
    setSelectedItem(item);
    setDeleteStatus(item.active);
    document.body.classList.add("overflow-hidden");
    window.scrollTo(0, 0);
    setShowConfirmModal(true);
  };

  const confirmHandler = (action) => {
    document.body.classList.remove("overflow-hidden");
    setShowConfirmModal(false);
    if (action) {
      onDelete(selectedItem);
    }
  };

  const onViewHandler = (item) => {
    setSelectedItem(item);
    document.body.classList.add("overflow-hidden");
    window.scrollTo(0, 0);
    setShowModal(true);
  };

  return (
    <div className="p-4">
      <Pagination
        className="mb-3"
        paginationConfig={paginationConfig}
        onNavigation={onNavigationHandler}
      />
      {showConfirmModal && (
        <Modal onClose={onClose} className="cb-small">
          <ConfirmModal
            description={`Are you sure want to ${
              +deleteStatus ? "de-activate" : "activate"
            }?`}
            onConfirmModal={confirmHandler}
          />
        </Modal>
      )}
      {showModal && (
        <Modal onClose={onClose} className="cb-large">
          <FundraisingView item={selectedItem} />
        </Modal>
      )}
      <Table striped bordered hover>
        <thead>
          <tr>
            <th width="100px">Id</th>
            <th>Project</th>
            <th width="200px">Lead Investors</th>
            <th width="250px">Investors</th>
            <th>Updated Date</th>
            <th>Updated By</th>
            <th>Active</th>
            <th width="115px">Action</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr key="loading">
              <td colSpan={10}>
                <Loading></Loading>
              </td>
            </tr>
          ) : (
            results.map((item, index) => {
              console.log(item);
              const { leadInvestors, investors, ...remainingItems } = item;
              return (
                <tr key={item.id + "_" + index}>
                  <td>#P{item.id}</td>
                  <td>
                    <ProjectLogo logo={item.project} path="projects" />
                  </td>
                  <td>
                    <Investor investors={leadInvestors} />
                  </td>
                  <td>
                    <Investor investors={investors} />
                  </td>
                  <td>
                    <DateFormat date={Date.parse(item.modifiedAt)} />
                  </td>
                  <td>{item.username}</td>
                  <td>
                    <Status value={item.active} />
                  </td>
                  <td>
                    <div className="btn-container">
                      <Button
                        className="mr-2"
                        variant="secondary"
                        onClick={() => onRemoveHandler(item)}
                      >
                        <i className="fas fa-trash text-gray-400"></i>
                      </Button>
                      <Button
                        className="mr-2"
                        variant="secondary"
                        onClick={() => onViewHandler(item)}
                      >
                        <i className="fas fa-desktop text-gray-400"></i>
                      </Button>
                      <Link
                        to={{
                          pathname: "/admin/fundraising/form",
                          data: {
                            ...remainingItems,
                            leadInvestorIds: leadInvestors,
                            investorIds: investors,
                            projectId: item.project.id
                          },
                        }}
                      >
                        <Button className="float-right" variant="secondary">
                          <i className="fas fa-edit text-gray-400"></i>
                        </Button>
                      </Link>
                    </div>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </Table>
      <Pagination
        paginationConfig={paginationConfig}
        onNavigation={onNavigationHandler}
      />
    </div>
  );
};

export default FundraisingList;